import { Edit } from 'react-admin'
import { CompanyEditForm } from './components/CompanyEditForm'

export const CompanyEdit = () => (
  <Edit mutationMode="pessimistic" redirect="show">
    <CompanyEditForm />
  </Edit>
)
